import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes, FundService } from '@gs-2.0/core';

import FundTypes from '../constants/fund-types';

export const projectFundRouteGuard: CanActivateFn = () => {
  const fundService = inject(FundService);
  const router = inject(Router);

  if (fundService.fundType() === FundTypes.PROJECT) {
    router.navigate([AppRoutes.FUND_DASHBOARD]);
    return false;
  }

  return true;
};
